import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ErrorPolicyService, SanitizedError } from '@mri-platform/angular-error-handling';
import {
  defaultErrorNotificationOptions,
  enrollmentErrorMsg,
  enrollmentSuccessMsg,
  getDefaultSuccessNotificationOptions
} from '@mri-platform/import-export/common-state';
import { NotificationService } from '@progress/kendo-angular-notification';
import { Observable } from 'rxjs';
import { map, mapTo } from 'rxjs/operators';
import { UserEnrollmentCallBackResponse } from '../models';
import { UserEnrollmentService } from './user-enrollment.service';

@Injectable({
  providedIn: 'root'
})
export class UserEnrollmentCallbackGuard implements CanActivate {
  constructor(
    private userEnrollService: UserEnrollmentService,
    private router: Router,
    public errorPolicy: ErrorPolicyService,
    private notificationService: NotificationService
  ) {}
  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const params = _next.queryParams as UserEnrollmentCallBackResponse;
    const errorOptions = {
      sanitizer: (err: HttpErrorResponse) =>
        new SanitizedError({ isError: true, message: err.error.detail, ngOriginalError: err }),
      notify: false
    };
    return this.userEnrollService.getCallBack(params).pipe(
      this.errorPolicy.catchHandle(() => errorOptions),
      map(userCallBack => {
        if (SanitizedError.is(userCallBack)) {
          this.notifyError(userCallBack.message ?? enrollmentErrorMsg);
        } else {
          this.notificationService.show(getDefaultSuccessNotificationOptions(enrollmentSuccessMsg));
        }
        this.router.navigate(['/']);
        return userCallBack;
      }),
      mapTo(false)
    );
  }

  notifyError(content: string) {
    this.notificationService.show({
      ...defaultErrorNotificationOptions,
      closable: true,
      hideAfter: undefined,
      content
    });
  }
}
